import service from "./service"

const verificationImageOfAnalysis = async (preCheckVeriffId, imageType) => {
    return service(preCheckVeriffId, imageType)
}

export default verificationImageOfAnalysis
